import { render, staticRenderFns } from "./index.vue?vue&type=template&id=113bde8e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113bde8e')) {
      api.createRecord('113bde8e', component.options)
    } else {
      api.reload('113bde8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=113bde8e", function () {
      api.rerender('113bde8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/plain/sidebar/index.vue"
export default component.exports